var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-row', [_c('v-col', [_vm._v(" " + _vm._s(_vm.getTeamName) + " ")]), _c('v-col', [_c('div', {
    staticClass: "top float-right"
  }, [_vm.canManageTeam ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('span', _vm._g({}, on), [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.leaveModal = true;
            }
          }
        }, [_c('v-icon', [_vm._v("exit_to_app")])], 1)], 1)];
      }
    }], null, false, 2734211279)
  }, [_c('span', [_vm._v(" Leave Team ")])]) : _vm._e(), _vm.canManageTeam ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('span', _vm._g({}, on), [_c('v-btn', {
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("mdi-delete")])], 1)], 1)];
      }
    }], null, false, 2421637659)
  }, [_c('span', [_vm._v(" Delete Team ")])]) : _vm._e()], 1)])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-list', [_vm._l(_vm.optionList, function (option, index) {
    return [option.show ? _c('v-list-item', {
      key: index,
      class: _vm.selectedOption === option.value ? 'primary ' : '',
      on: {
        "click": function click($event) {
          return _vm.setAction(option.value);
        }
      }
    }, [_c('div', {
      class: _vm.selectedOption === option.value ? 'white--text ' : ''
    }, [_vm._v(" " + _vm._s(option.title) + " ")])]) : _vm._e()];
  })], 2)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "flat": ""
    }
  }, [_vm.selectedOption === 1 ? _c('update-team-info') : _vm._e()], 1), _vm.selectedOption === 2 && !_vm.showVerificationForm ? _c('transfer-ownership', {
    on: {
      "success": _vm.openVerificationForm
    }
  }) : _vm._e(), _vm.selectedOption === 2 && _vm.showVerificationForm && !_vm.showSuccessMessage ? _c('verification-code-checker', {
    attrs: {
      "memberDetail": _vm.selectedMember,
      "action": "transfer_ownership",
      "from-verify-ownership": ""
    },
    on: {
      "next": _vm.afterVerify
    }
  }) : _vm._e(), _vm.selectedOption === 2 && _vm.showSuccessMessage ? _c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-alert', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(" You have successfully transfer you ownership. Now you can leave a team. ")])], 1) : _vm._e(), _vm.selectedOption === 3 ? _c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subListFont"
  }, [_vm._v("Delete my account after")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.deleteOptions,
      "filled": "",
      "item-text": "text",
      "item-value": "value",
      "label": "Select duration"
    },
    model: {
      value: _vm.deleteTime,
      callback: function callback($$v) {
        _vm.deleteTime = $$v;
      },
      expression: "deleteTime"
    }
  })], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "text-transform-none",
    attrs: {
      "outlined": _vm.$vuetify.theme.dark,
      "color": "primary",
      "large": ""
    }
  }, [_vm._v(" Update ")]), _c('v-spacer')], 1)], 1) : _vm._e()], 1)], 1)], 1), _c('Modal', {
    attrs: {
      "no-py": ""
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_vm.leaveModal ? _c('leave-team-modal', {
          on: {
            "close": function close($event) {
              _vm.leaveModal = false;
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.leaveModal,
      callback: function callback($$v) {
        _vm.leaveModal = $$v;
      },
      expression: "leaveModal"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }